var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","text-align":"center","padding":"8px"}},[_c('img',{staticStyle:{"max-height":"100%","max-width":"100%"},attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }